import store from "@/base/store";

import forms from "@/esf_antarctica_lederhosenland/store/modules/forms";
import headerlogo from "@/esf_antarctica_lederhosenland/store/modules/headerlogo";
store.registerModule("forms", forms);
store.registerModule("headerlogo", headerlogo);
export default store;
